/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { HappinessMeter } from 'aurora-section-components';
import messages from 'aurora-translations';
import Chip from '@material-ui/core/Chip';
import { getPropertType, keyEmptyCheck, isFeedbackProvided } from 'aurora-utils/utils';
import ADGMImage from '../../ADGMImage';
import styles from './styles';
import ADGMItemDetails from '../../ADGMItemDetails/ADGMItemDetails';

function Success(props) {
  const {
    classes,
    history,
    type,
    title,
    subTitle,
    data,
    downloadhandler,
    isShowPdfButton,
    downloadPaymentHandler,
  } = props;
  const locale = localStorage.getItem('lang');
  const goToPropertyHandler = () => {
    history.push('/');
  };

  const propertytitle = [];
  const renderIcon = typeIcon => {
    if (typeIcon === 'rejection') {
      return 'contractImage.svg';
    }
    if (typeIcon === 'termination') {
      return 'errorIcon.svg';
    }
    if (typeIcon === 'dmtPayment') {
      return 'DMTPaymentuccess.svg';
    }
    return 'successIcon.svg';
  };
  const renderClass = typeClass => {
    if (typeClass === 'rejection') {
      return classes.textHolder;
    }
    if (typeClass === 'termination') {
      return classes.textHolderTermination;
    }
    if (typeClass === 'dmtPayment') {
      return classes.textHolderApproval;
    }
    return classes.textHolderApproval;
  };
  if (locale === 'en') {
    if (data?.property?.districtEn) propertytitle.push(data?.property?.districtEn);
    if (data?.property?.communityEn) propertytitle.push(data?.property?.communityEn);
  } else {
    if (data?.property?.districtAr) propertytitle.push(data?.property?.districtAr);
    if (data?.property?.communityAr) propertytitle.push(data?.property?.communityAr);
  }
  if (data?.property?.plotNumber) propertytitle.push(data?.property?.plotNumber);
  const owner = data?.application?.owners?.length > 0 ? data?.application?.owners[0] : {};
  const tenants = data?.application?.tenants;
  const propertyType = getPropertType(data?.property?.propertyType);
  const isFeedbackGiven = isFeedbackProvided(
    data?.application?.applicationDetails?.initiatorUserId,
    data?.application?.applicationDetails?.happinessMeter,
    data?.application?.applicationDetails?.applicationStatus,
  );
  return (
    <Container className={classes.container}>
      {!isFeedbackGiven && (
        <HappinessMeter
          applicationNumber={data?.application?.applicationDetails?.applicationNumber}
          applicationId={data?.application?.applicationDetails?.applicationId}
          applicationType={data?.application?.applicationDetails?.applicationType}
        />
      )}
      <Grid container spacing={3} justify='center'>
        <Grid item xs={12} md={8}>
          <div className={classes.contentArea}>
            <div className={classes.bannerArea}>
              <div>
                <ADGMImage name={renderIcon(type)} alt='success img' />
              </div>
              <div className={renderClass(type)}>
                <Typography variant='h6' component='h1' className={classes.Title}>
                  {title}
                </Typography>
                <Typography variant='body1'>{subTitle}</Typography>
                {isShowPdfButton === true || typeof downloadPaymentHandler === 'function' ? (
                  <Box display='grid' gridGap={10} gridTemplateColumns={['1fr', '1fr 1fr']}>
                    {isShowPdfButton === true ? (
                      <Button className={classes.textDownload} onClick={downloadhandler}>
                        <ADGMImage name='Download-Icon.svg' alt='Icon' width='16px' height='16px' />
                        <FormattedMessage {...messages.download_contract} />
                      </Button>
                    ) : null}
                    {typeof downloadPaymentHandler === 'function' && (
                      <Button className={classes.textDownload} onClick={downloadPaymentHandler}>
                        <ADGMImage name='Download-Icon.svg' alt='Icon' width='16px' height='16px' />
                        {keyEmptyCheck('download_payment_receipt')}
                      </Button>
                    )}
                  </Box>
                ) : null}
              </div>
            </div>

            {/* Test */}
            <div className={classNames(classes.detailItem, classes.itemRight)}>
              <Typography align='right'>
                <FormattedMessage {...messages.Application_ID} />:
                <strong>{data?.application?.applicationDetails?.applicationNumber}</strong>
              </Typography>
            </div>

            <div className={classes.detailItemHorizontal}>
              <div className={classes.item}>
                <ADGMItemDetails label='property' value={propertytitle.join(',')} />
              </div>
              <Chip
                label={keyEmptyCheck(propertyType)}
                className={classNames(classes.darkgreen, classes.initibadges)}
              />
            </div>
            <div className={classes.detailItem}>
              <ADGMItemDetails label='owner' value={locale === 'en' ? owner?.ownerNameEn : owner?.ownerNameAr} />
            </div>
            <div className={classes.detailItem}>
              {tenants?.map((tenant, index) => (
                <ADGMItemDetails
                  label='musateh'
                  labelPlaceholder={{ s: index + 1 }}
                  value={locale === 'en' ? tenant.nameEn : tenant.nameAr}
                />
              ))}
            </div>
            <div className={`${classes.detailItem} ${classes.item}`}>
              <div>
                <ADGMItemDetails
                  label='contract_remaining_amount'
                  value={Math.abs(data?.application?.contractDetails?.contractRemainingAmount)}
                  valueClass={classes.totalAmount}
                  isAmount
                />
              </div>
              <div style={{ marginTop: '10px' }}>
                <ADGMItemDetails
                  label='registration_fee'
                  value={Math.abs(data?.application?.contractDetails?.contractRemainingAmount * 0.036)}
                  isAmount
                />
              </div>
            </div>
            {/* End Test */}
            <div className={classes.footerBtnHolder}>
              <Button variant='contained' className={classes.gotoproBtn} onClick={goToPropertyHandler}>
                <FormattedMessage {...messages.go_to_properties} />
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
}

Success.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  isShowPdfButton: PropTypes.bool.isRequired,
  downloadhandler: PropTypes.func.isRequired,
  downloadPaymentHandler: PropTypes.func,
};

Success.defaultProps = {
  downloadPaymentHandler: undefined,
};

export default withStyles(styles)(Success);
